import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAuth } from '../contexts/AuthContext';

const LoadingWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '60vh',
  backgroundColor: '#fafafa',
});

const PrivateRoute = ({ children }) => {
  const { user, loading, authChecked } = useAuth();
  const location = useLocation();

  // Show nothing while doing the initial auth check
  if (!authChecked) {
    return null;
  }

  // Show loading spinner only during explicit auth operations (login, signup, etc.)
  if (loading) {
    return (
      <LoadingWrapper>
        <CircularProgress sx={{ color: '#1a1a1a' }} />
      </LoadingWrapper>
    );
  }

  if (!user) {
    // Save the attempted URL for redirecting after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
